import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, selectMode } from '../../../service/slice/ThemeSlice';
import { MdOutlineLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import img1 from "../../../adminassets/img/background.png";
import logo from "../../../studentassets/logo.png";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";


export default function AdminOtpVerify() {

    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    const navigate = useNavigate();
    const location = useLocation();

    const receivedData = location.state;
    const email = receivedData?.email;


    const theme = useSelector(selectMode);
    const dispatch = useDispatch();
    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24'
    };

    const handleChange = (value, index) => {
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // auto move to next input
            if (value && index < 5) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }
    };

    function validatePassword(password) {
        const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return re.test(password);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const numberValue = Number(otp.join(""));

        const otpData = {
            otp: numberValue,
            password: password,
            confirmPassword: confirmPassword,
            email
        };

        if (!validatePassword(password)) {
            toast.info("Password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }
        if (!validatePassword(confirmPassword)) {
            toast.info("Confirm password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }

        if (password !== confirmPassword) {
            toast.error("Password and Confirm Password should be same!");
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/otpvalidate`, {
                method: "POST",
                mode: 'cors',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(otpData),
            });

            const data = await response.json();
            console.log("Otpverify response:", data);

            if (data.status === true) {
                toast.success("OTP verified or password reset successfully!");
                navigate('/adminsignin');
            } else {
                toast.error("Invalid OTP or password. Please try again.");
                navigate("/adminotpverify", { state: { email: email } });
            }

            setOtp(["", "", "", "", "", ""]);
            setPassword("");
            setConfirmPassword("");

        } catch (error) {
            console.log("Error during signup:", error);
        }
    };

    return (
        <>
            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white py-2 fixed-top" style={{ ...themeColor, height: "80px" }}>
                <div className="container-fluid">
                    {/* Logo */}
                    <Link to="/" className="navbar-brand">
                        <img src={logo} alt="Logo" style={{ width: '96px', marginTop: "0.4em" }} />
                    </Link>

                    {/* Right Side */}
                    <div className="d-flex align-items-center gap-3 d-none d-md-flex">

                        <button className="theme-toggle-btn" onClick={() => dispatch(toggleMode())} style={themeColor}>
                            {theme === "light" ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                        </button>

                    </div>
                </div>
            </nav>


            <div className="">
                <div className="row vh-100">

                    <div className="col-12 col-md-6 p-0 ms-0">
                        <img src={img1} alt="img" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
                    </div>


                    <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
                        <form className="w-75" onSubmit={(event)=>{handleSubmit(event)}}>
                            <h2 className="mb-4 text-center">Admin Otp Verify</h2>

                            <div className="container">
                                <div className="row justify-content-center otp-inputs">
                                    {otp.map((digit, index) => (
                                        <div className="col-2 col-sm-1 p-1 d-flex justify-content-center">
                                            <input type="text" key={index} id={`otp-${index}`} name="otp" maxLength="1" value={digit} onChange={(event) => handleChange(event.target.value, index)} className="form-control text-center otp-box" required />
                                        </div>
                                    ))}
                                </div>
                            </div>


                            <div className="mb-3 password-container">
                                <label className="form-label">Password</label>
                                <div className="input-wrapper">
                                    <input className="form-control form-control-lg" type={showPassword ? "text" : "password"} value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Password" required />
                                    <button type="button" onClick={togglePassword} className="password-toggle">
                                        {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                    </button>
                                </div>
                            </div>

                            <div className="mb-3 password-container">
                                <label className="form-label">Password</label>
                                <div className="input-wrapper">
                                    <input className="form-control form-control-lg" type={showConfirmPassword ? "text" : "password"} value={confirmPassword} onChange={(event) => { setConfirmPassword(event.target.value) }} placeholder="Confirm Password" required />
                                    <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="password-toggle">
                                        {showConfirmPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                    </button>
                                </div>
                            </div>


                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary btn-lg">
                                    Send Link
                                </button>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </>
    )
}
